/**
 * @generated SignedSource<<5126f622b2ae8164bb2c13a7d1b90395>>
 * @relayHash 45572fe1b9eb6de0dfbaf2f842a3ba1c
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID d76fa6613144ca0b5385c7d7365506dd33267d06634f959c28b9d3cd30b5bddb

import type { PreloadableConcreteRequest } from 'relay-runtime';
import type { DeploymentDetailsPopupUiQuery } from './DeploymentDetailsPopupUiQuery.graphql';

const node: PreloadableConcreteRequest<DeploymentDetailsPopupUiQuery> = {
  "kind": "PreloadableConcreteRequest",
  "params": {
    "id": "d76fa6613144ca0b5385c7d7365506dd33267d06634f959c28b9d3cd30b5bddb",
    "metadata": {},
    "name": "DeploymentDetailsPopupUiQuery",
    "operationKind": "query",
    "text": null
  }
};

export default node;
